<template>
  <div>
    <Form class="modalFormWrap formStyle" ref="form" :model="info" label-position="left" :rules="rules">
      <FormItem prop="oldPassword" label="原密码">
        <Input type="password" v-model="info.oldPassword"></Input>
      </FormItem>
      <FormItem prop="newPassword" label="新密码">
        <Input type="password" v-model="info.newPassword"></Input>
      </FormItem>
      <FormItem prop="confirmPassword" label="确认新密码">
        <Input type="password" v-model="info.confirmPassword"></Input>
      </FormItem>
    </Form>
    <div class="changeBtn"><Button class="defaultBtn formBtn" shape="circle" :loading="submitting" @click="submit">确认修改</Button> </div>   
  </div>
</template>

<script>
import centerService from "@/api/center";
export default {
  data() {
    return {
      info: {},
      rules: {
        oldPassword: [
          { required: true, message: "内容不能为空", trigger: "blur" }
        ],
        newPassword: [
          {
            required: true,
            message: "密码需8-16位数字英文符号两种以上组合",
            pattern: /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?![?~!=,#&@$%.+*()|{}"<>'\-:;^_`]+$)[?~!=,#&@$%.+*()|{}"<>'\-:;^_`0-9A-Za-z]{8,16}$/
          }
        ],
        confirmPassword: [
          {
            required: true,
            message: "内容不能为空，需与新密码相同",
            validator: (rule, value) => {
              if (!value || value != this.info.newPassword) {
                return false;
              }
              return true;
            }
          }
        ]
      },
      submitting: false
    };
  },
  methods: {
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitting = true;
          centerService
            .changePwd(this.info)
            .then(res => {
              if (res.errorNo == 0) {
                this.$Message.success("密码修改成功！");
                this.$emit("ChangePwdSuccess");
              } else {
                this.$Message.error(res.errorMessage);
              }
              this.submitting = false;
            })
            .catch(() => {
              this.submitting = false;
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        } else {
          this.$Message.error("信息未填写完整");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.changeBtn {
  padding-top: 20px;
  text-align: center;
}
</style>
